import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';

// The raised button style from the redesign — as used by the header
// booking button and the login submit (HeaderMenu / FancyButton).
const useStyles = createUseStyles((theme: Theme) => ({
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    whiteSpace: 'nowrap',
    fontSize: 14,
    fontFamily: 'inherit',
    cursor: 'pointer',
    padding: 10,
    background: 'white',
    color: theme.colors.primaryBlack,
    border: '1px solid #ededed',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
    borderRadius: theme.primaryBorderRadius,
    transition: 'background-color 0.15s',
    '&:hover': {
      backgroundColor: '#ebebec'
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'default'
    }
  },
  primary: {
    background: '#0b57ff',
    color: theme.colors.primaryWhite,
    border: '1px solid rgba(255, 255, 255, 0.18)',
    boxShadow:
      '0 1px 2px rgba(11, 87, 255, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.12)',
    '&:hover': {
      backgroundColor: '#0a4cdf'
    }
  }
}));

type Props = React.PropsWithChildren<{
  primary?: boolean;
  onClick?: (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  className?: string;
}>;

export default function RaisedButton({
  primary,
  onClick,
  disabled,
  className,
  children
}: Props) {
  const classes = useStyles();

  return (
    <button
      type="button"
      className={`${classes.button} ${primary ? classes.primary : ''} ${
        className ?? ''
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
